/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useContext } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import './style.scss';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { usePapaParse } from 'react-papaparse';

import { Consulta, SubformEditar } from 'src/components/table/formularios';

import { LoadGif } from '../LoadGif';

import {
  getDinamyc,
  getMovimento,
  isValid,
  GetProcesso,
  transformJson,
} from 'src/services/auth';

import { ReactComponent as SearchFolder } from 'src/assets/icons/searchFolder.svg';
import { ReactComponent as AddFolder } from 'src/assets/icons/addFolder.svg';
import { ReactComponent as Edit } from 'src/assets/icons/edit.svg';
import { ReactComponent as Board } from 'src/assets/icons/board.svg';
import { ReactComponent as Print } from 'src/assets/icons/print.svg';
import { ReactComponent as Download } from 'src/assets/icons/download.svg';
import { ReactComponent as Upload } from 'src/assets/icons/upload.svg';
import { ReactComponent as Delete } from 'src/assets/icons/end.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';

import { ReactComponent as ConsultaIcon } from 'src/assets/icons/oldPortal/consulta.svg';
import { ReactComponent as AdicionarIcon } from 'src/assets/icons/oldPortal/adicionar.svg';
import { ReactComponent as Pdf } from 'src/assets/icons/pdf.svg';

import FormularioAdicao from './formularios/formularioAdicao';

import showToast from 'src/components/toastyService';

import { LogContext } from '../LogProvider';

import { Toogle } from '../customInput';
import { RenderForm } from '../customInput/renderForm';
import { RenderPdf } from '../renderPdf';
import { newTab } from 'src/pages/home';

export default function Table({
  selectedTable,
  selectedItem,
  ClassName,
  tabIndex,
}) {
  const idEmp = localStorage.getItem('idEmp');
  const idFil = localStorage.getItem('idFil');

  const { setLogData, setLoadIndex } = useContext(LogContext);
  const [load, setLoad] = useState(true);

  const [thisPorta, setThisPorta] = useState();
  const [portaDefault, setPortaDefault] = useState();
  const [tableBody, setTableBody] = useState();
  const [tableTitle, setTableTitle] = useState();
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);

  const [newTableData, setNewTableData] = useState([]);
  const [newTableColumns, setNewTableColumns] = useState([]);
  const [recursividade, setRecursividade] = useState(null);
  const [showDowload, setShowDowload] = useState(null);
  const [showSave, setShowSave] = useState({});
  const [showDelete, setShowDelete] = useState({});
  const [enableRecursividade, setEnableRecursividade] = useState(false);
  const [corFundo, setCorFundo] = useState('');

  const [subformData, setSubformData] = useState();
  const [showPopup, setShowPopup] = useState('');
  const [forcePopup, setForcePopup] = useState(false);
  const [subformControls, setSubformControls] = useState([]);
  const [consultaAdi, setConsultaAdi] = useState([]);

  const [relatorios, setRelatorios] = useState([]);
  const [relatorioModal, setRelatorioModal] = useState(false);

  const { readString, jsonToCSV } = usePapaParse();

  const [lastSearch, setLastSearchCache] = useState({});

  function setLastSearch(data) {
    const cache = JSON.parse(localStorage.getItem('cache')) || [];

    const newCache = cache.filter((item) => item.key !== `${thisPorta}search`);
    newCache.push({ key: `${thisPorta}search`, value: data });

    setLastSearchCache(data);
    localStorage.setItem('cache', JSON.stringify(newCache));
  }

  useEffect(() => {
    setTableData([]);
    setTableTitle('');
    setNewTableColumns([]);

    const porta = isValid(selectedItem.porta)
      ? selectedItem.porta
      : selectedTable.porta;

    setThisPorta(porta);

    setLoad(true);

    const data = {
      codemp: idEmp,
      codfil: idFil,
      tipAca: 'ADI',
    };

    GetProcesso(porta, data, true, true)
      .then((res) => {
        setConsultaAdi(res);
        setTableData(res);

        const colunas = JSON.parse(res.nomeColunas);

        setPortaDefault(colunas?.Dados?.endpoint?.consultar);
        setTableTitle(colunas?.Dados?.titulo);
        setRecursividade(colunas?.Dados?.repete);
        setShowDowload(colunas?.Dados?.downloadupload === 'S');
        setShowSave(colunas?.Dados?.gridsalvar === 'S');
        setShowDelete(colunas?.Dados?.griddeletar === 'S');

        const newColumns = Object.entries(colunas.Dados)
          .filter(
            ([key, value]) =>
              key !== 'relatorios' &&
              key !== 'endpoint' &&
              key !== 'titulo' &&
              value.grid === 'S'
          )
          .sort((a, b) => (a[1].posicao || 0) - (b[1].posicao || 0)) // <-- ordena por posicao
          .map(([key, value]) => ({
            header: value.nome,
            accessorKey: key.toLowerCase(),
          }));

        setCorFundo(colunas?.Dados?.corfundo);

        setNewTableColumns(newColumns);
      })
      .catch((error) => {
        showToast('error', error);
      })
      .finally(() => {
        setLoad(false);
      });

    const cache = JSON.parse(localStorage.getItem('cache')) || [];
    const cacheSearch =
      cache.find((item) => item.key === `${porta}search`) || {};
    if (isValid(cacheSearch)) setLastSearchCache(cacheSearch.value);
    else setLastSearchCache({ inicio: '', fim: '' });
  }, [selectedTable]);

  function ForceUpdate() {
    setForcePopup(true);
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: '#0fa697',
      },
      secondary: {
        main: '#0fa697',
      },
    },
    components: {
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            color: '#0b4e5c',
          },
          outlined: {
            borderColor: '#0b4e5c',
          },
          outlinedPrimary: {
            '&.Mui-selected': {
              backgroundColor: '#0b4e5c',
              color: 'white',
            },
          },
        },
      },

      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: '#0b4e5c', //checkbox
            '&.Mui-checked': {
              color: '#0b4e5c !important', //checkbox selecionado
            },
          },
        },
      },

      MuiSvgIcon: {
        styleOverrides: {
          root: {
            color: '#0b4e5c',
            '&.Mui-selected': {
              color: '#0b4e5c !important',
            },
          },
        },
      },
    },
  });

  function updateTable() {
    if (tableData?.length > 0) {
      setNewTableData(tableData);
    } else {
      setNewTableData([]);
    }
  }

  const formatData = (data) => {
    const [dataAno, dataMes, dataDia] = data.split('-');
    return `${dataDia}/${dataMes}/${dataAno}`;
  };
  useEffect(() => {
    updateTable();
  }, [tableData]);
  useEffect(() => {
    if (!enableRecursividade) return;

    const timing = recursividade > 5000 ? parseFloat(recursividade) : 5000;

    const intervalId = setInterval(() => {
      const inicio =
        lastSearch?.inicio ?? new Date().toISOString().split('T')[0];
      const fim = lastSearch?.fim ?? new Date().toISOString().split('T')[0];

      if (isValid(inicio) && isValid(fim)) {
        //setLoad(true);
        const formatInicio = formatData(inicio);
        const formatFim = formatData(fim);

        const porta = thisPorta;

        const idEmp = localStorage.getItem('idEmp');
        const idFil = localStorage.getItem('idFil');
        const data = {
          codemp: idEmp,
          codfil: idFil,
          datini: formatInicio,
          datfim: formatFim,
          tipAca: 'C',
        };

        if (isValid(porta)) {
          GetProcesso(porta, data, true, true)
            .then((res) => {
              const colunas = JSON.parse(res?.nomeColunas);
              const dados = res?.dadosGerais;

              setTableColumns(colunas);
              setTableData(dados);

              setTimeout(() => {
                setLoad(false);
              }, 1000);
            })
            .catch((error) => {
              showToast('error', error);
            });
        } else {
          //setLoad(false);
          showToast('error', 'Porta inválida.');
          setTimeout(() => {
            showToast('warning', 'Desativando recursividade.');
            setEnableRecursividade(false);
          }, 1000);
        }
      }

      updateTable();
    }, timing);

    return () => clearInterval(intervalId);
  }, [enableRecursividade, recursividade, tableData]);

  function handleEdit(row) {
    setLoad(true);
    const allData = newTableData.find((item) => item.codord === row.codord);

    const newData = allData ? { ...allData, ...row } : allData;

    if (!isValid(row) || !isValid(allData) || !isValid(newData)) {
      showToast('error', 'Erro ao tentar salvar edição');
      setLoad(false);
      return;
    }

    const postConfig = {
      codemp: allData.codemp,
      codfil: allData.codfil,
      tipAca: 'GA',
      ...newData,
    };

    GetProcesso(thisPorta, postConfig, true, true);

    setTimeout(() => {
      setLoad(false);
    }, 1000);
  }
  function handleSave(rows) {
    const rowsToAdd = rows.map((item) => item.original);

    const newRowsToAdd = rowsToAdd.map((item) => ({
      ...item,
      tipaca: 'GI',
    }));
  }
  function handleDelete(rows) {
    let rowsToDelete;

    if (Array.isArray(rows)) {
      rowsToDelete = rows.map((item) => item.original);

      const newRowsToDelete = rowsToDelete.map((item) => ({
        ...item,
        tipaca: 'GR',
      }));
    } else {
      rowsToDelete = rows.original;

      const postConfig = {
        codemp: rowsToDelete.codemp,
        codfil: rowsToDelete.codfil,
        tipAca: 'GR',
        ...rowsToDelete,
      };

      GetProcesso(thisPorta, postConfig, true, true);
    }
  }

  const [subformConfig, setSubformConfig] = useState({});
  const [selectedRow, setSelectedRow] = useState({});
  function handleCallSubform(data) {
    setLoad(true);
    setSelectedRow(data);
    //setShowPopup('load');

    const tipo = parseFloat(data.tipcar);
    const empresa = data.codemp;
    const filial = data.codfil;
    const ordem = parseInt(data.codord);
    const acao = 'CID';

    const porta = isValid(selectedItem.porta)
      ? selectedItem.porta
      : selectedTable.porta;

    let config = [porta, empresa, filial, ordem, acao];
    setSubformConfig(config);

    /*const params = Object.entries(data)
      .map(([key, value]) => `<${key}>${value}</${key}>\n `)
      .join('');*/

    const { tipaca, ...noTipAca } = data;
    const thisData = { ...noTipAca, tipAca: 'CID' };

    GetProcesso(porta, thisData, true, true)
      .then((res) => {
        setSubformData(res);

        const extractedControls = Object.keys(res).filter((key) =>
          key.toLowerCase().includes('colunas')
        );

        setSubformControls(extractedControls);

        setShowPopup('subformConsulta');
      })
      .catch((error) => {
        showToast('error', error);
      })
      .finally(() => setLoad(false));
  }

  const isMobile = window.innerWidth <= 768;
  const table = useMaterialReactTable({
    data: newTableData,
    columns: newTableColumns,

    enableGlobalFilter: true,
    enableEditing: true,
    editDisplayMode: 'row',
    enableColumnPinning: true,
    enableRowSelection: true,
    enableFullScreenToggle: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    rowPinningDisplayMode: 'top-and-bottom',

    layoutMode: 'grid-no-grow',

    enableColumnResizing: true,
    columnResizeMode: 'onEnd',

    onEditingRowSave: (row) => handleEdit(row.values),

    initialState: {
      showGlobalFilter: true,
      density: 'compact',
      columnPinning: !isMobile
        ? { left: ['mrt-row-select', 'mrt-row-actions'] }
        : {},
      pagination: { pageSize: 15 },
    },

    muiTopToolbarProps: {
      className: 'myTable-toolbar',
    },

    muiSearchTextFieldProps: {
      sx: { width: '100%' },
      InputProps: {
        sx: { width: '100%' },
      },
    },

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    muiTableContainerProps: {
      sx: {
        flex: 1,
        height: '100%',
        maxHeight: 'calc(100% - 6.5rem)',
        overflow: 'auto',
      },
    },

    muiTableHeadCellProps: ({ column }) => ({
      align: 'center',
      title: column.columnDef.header,
      sx: {
        '& .Mui-TableHeadCell-Content-Labels': {
          padding: 0,
        },
      },
    }),

    muiTableBodyCellProps: ({ cell, column, row }) => ({
      align: 'center',
      title: cell.getValue?.() ?? '',
      sx: {
        borderRight: '1px solid #00000010',
        backgroundColor: row.original.corlin || 'transparent',
        '&:before': {
          backgroundColor: `${row.original.corlin} !important`,
        },
      },
    }),

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: 'pointer',
        backgroundColor: row.original.corlin || 'transparent',
        color: row.original.cortex || 'inherit',
      },
    }),

    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: true,
      variant: 'outlined',
    },

    paginationDisplayMode: 'pages',

    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 80,
        minSize: 80,
        maxSize: 80,

        muiTableHeadCellProps: { sx: { width: '80px' } },
        muiTableBodyCellProps: ({ row }) => ({
          sx: {
            width: '80px',
            opacity: 1,
            backgroundImage: 'none',
            backgroundColor: row.original.corlin || 'transparent',
            color: row.original.cortex || 'inherit',
            '&:before': {
              backgroundColor: 'transparent !important',
            },
          },
        }),
      },
      'mrt-row-select': {
        size: 30,
        minSize: 30,
        maxSize: 30,
        muiTableHeadCellProps: { sx: { width: '30px' } },
        muiTableBodyCellProps: ({ row }) => ({
          sx: {
            width: '30px',
            opacity: 1,
            backgroundImage: 'none',
            backgroundColor: row.original.corlin || 'transparent',
            color: row.original.cortex || 'inherit',
            '&:before': {
              backgroundColor: 'transparent !important',
            },
          },
        }),
      },
    },

    renderRowActions: ({ row, table }) => (
      <>
        <Tooltip title="Detalhes">
          <IconButton
            className="ActionButton"
            onClick={() => handleCallSubform(row.original)}
          >
            <Board className="tableIcon" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Imprimir">
          <IconButton
            className="ActionButton"
            onClick={() => {
              setRelatorios([]);

              const dadosDaLinha = {
                ...row.original,
                porta: selectedItem?.porta,
              };

              const data = { arqJso: JSON.stringify(dadosDaLinha) };

              setLoad(true);
              GetProcesso('SetRelatorio', data, true, false)
                .then((res) => {
                  const dados = JSON.parse(res.arqJso);
                  setRelatorios(dados.Dados);

                  if (dados.Dados.length > 1) {
                    setRelatorioModal(true);
                  } else if (dados.Dados.length === 1) {
                    newTab(
                      dados.Dados[0].nome,
                      <RenderPdf data={dados.Dados[0].base64} />
                    );
                  }
                })
                .finally(() => setLoad(false));
            }}
          >
            <Print className="tableIcon" />
          </IconButton>
        </Tooltip>
      </>
    ),

    localization: {
      ...MRT_Localization_PT_BR,
      noRecordsToDisplay: 'Consulta não efetuada.',
    },
  });

  const handleDownloadFile = () => {
    try {
      const csvData = jsonToCSV(JSON.stringify(newTableData), {
        delimiter: ';',
      });

      const element = document.createElement('a');
      const file = new Blob([csvData], { type: 'text/plain' });
      element.href = URL.createObjectURL(file);
      element.download = `itens-${lastSearch?.inicio}-${lastSearch?.fim}.csv`;
      element.click();
    } catch (error) {
      showToast('error', error);
    }
  };

  const handleUploadFile = () => {
    try {
      const element = document.createElement('input');
      element.type = 'file';
      element.accept = 'text/csv, .csv, application/vnd.ms-excel';
      element.addEventListener(
        'change',
        () => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const { data } = readString(e.target.result, {
              header: true,
            });
            setNewTableData(data);
          };
          reader.readAsText(element.files[0]);
        },
        { passive: true }
      );
      element.click();
    } catch (error) {
      showToast('error', error);
    }
  };

  useEffect(() => {
    setLoadIndex((prev) => ({
      ...prev,
      [tabIndex]: load,
    }));
  }, [load, showPopup]);

  return (
    <Box
      className={ClassName}
      sx={{ height: '100%', width: '100%', p: 1, position: 'relative' }}
    >
      {relatorioModal && (
        <div className={`modal absoluteCenter relatoriosModal listaRelatorios`}>
          {Array.isArray(relatorios) &&
            relatorios.map((item, index) => (
              <button
                key={index}
                className="relatorioItem"
                onClick={() => {
                  newTab(item.nome, <RenderPdf data={item.base64} />);
                }}
              >
                <Pdf />
                <span>
                  {item.nome}
                  <hr />
                </span>
              </button>
            ))}

          <span className="submitRow">
            <button
              className="mainButton turquoise"
              onClick={() => setRelatorioModal(false)}
            >
              retornar
            </button>
          </span>
        </div>
      )}

      <span className="tableTitle">
        <h1>{tableTitle}</h1>
      </span>

      {(showPopup != '' || forcePopup || relatorioModal) && (
        <button className="tableFade" />
      )}

      {(showPopup === 'load' || load) && <LoadGif />}

      <div className={`tableMenu ${load ? 'tableHide' : 'tableShow'}`}>
        <button
          className="mainButton turquoise"
          onClick={() => setShowPopup('adicao')}
        >
          <AdicionarIcon />
          Adicionar
        </button>

        <button
          className="mainButton yellow"
          onClick={() => setShowPopup('consulta')}
        >
          <ConsultaIcon />
          Consultar
        </button>

        {table.getSelectedRowModel().rows.length > 0 && showSave && (
          <button
            className="mainButton selectionAction turquoise"
            onClick={() => handleSave(table.getSelectedRowModel().rows)}
          >
            <Check />
            Salvar
          </button>
        )}
        {table.getSelectedRowModel().rows.length > 0 && showDelete && (
          <button
            className="mainButton selectionAction red"
            onClick={() => handleDelete(table.getSelectedRowModel().rows)}
          >
            <Delete />
            Deletar
          </button>
        )}

        {isValid(recursividade) && recursividade > 0 && (
          <div>
            <Toogle OnChange={(newValue) => setEnableRecursividade(newValue)} />
          </div>
        )}

        {showDowload && (
          <button className="menuButton" onClick={() => handleDownloadFile()}>
            <Download />
          </button>
        )}
        {showDowload && (
          <button className="menuButton" onClick={() => handleUploadFile()}>
            <Upload />
          </button>
        )}
      </div>

      {showPopup === 'consulta' && (
        <Consulta
          onClose={() => setShowPopup('')}
          setTableData={setTableData}
          setTableColumns={setTableColumns}
          config={subformConfig}
          lastSearch={lastSearch}
          setLastSearch={setLastSearch}
          porta={portaDefault}
          tabIndex={tabIndex}
        />
      )}
      {forcePopup && (
        <Consulta
          onClose={() => setForcePopup(false)}
          setTableData={setTableData}
          setTableColumns={setTableColumns}
          config={subformConfig}
          lastSearch={lastSearch}
          setLastSearch={setLastSearch}
          porta={portaDefault}
          tabIndex={tabIndex}
          forced={true}
        />
      )}

      {showPopup === 'adicao' && (
        <FormularioAdicao
          onClose={() => setShowPopup('')}
          setTableData={setTableData}
          setTableColumns={setTableColumns}
          adiData={consultaAdi}
          porta={thisPorta}
          tabIndex={tabIndex}
          forceUpdate={ForceUpdate}
        />
      )}

      {showPopup === 'subformConsulta' && (
        <SubformEditar
          onClose={() => {
            setShowPopup('');
          }}
          setTableData={setTableData}
          setTableColumns={setTableColumns}
          controls={subformControls}
          data={subformData}
          config={subformConfig}
          rowData={selectedRow}
          tabIndex={tabIndex}
          forceUpdate={ForceUpdate}
        />
      )}

      <div className="tableWrapper">
        <ThemeProvider theme={theme}>
          <MaterialReactTable table={table} />
        </ThemeProvider>
      </div>
    </Box>
  );
}
